<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t('view') }} {{ $t('usage') }} {{ $t('promotionsandoffer') }}</div>
      </div>
      <div class="d-flex align-items-center">
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button variant="default" to="promotions-and-offers" class="btn-blue">{{ $tc('list', 1) }}</b-button>
         <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $tc("of") }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper mt-3">
       <div class="row mb-2">
        <div class="col-3">
          <div>
            <b-form-input
              v-debounce:500="onSearchVoucherCode"
              v-model="searchValue"
              v-on:search="onSearchVoucherCode"
              type="search"
              :placeholder="$tc('searchs')"
            ></b-form-input>
          </div>
        </div>
        <div class="col-9">
          <div class="row justify-content-end">
            <div class="col-lg-6 col-xl-4 align-self-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="from_date"
                    v-on:click="from_date = ''"
                  >
                    ✖
                  </button>
                  <Datepicker
                    v-model="from_date"
                    ref="from_date"
                    typeable
                  ></Datepicker>
                  <label :class="from_date ? 'active' : ''">{{
                    $t("fromdate")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4 align-self-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="to_date"
                    v-on:click="to_date = ''"
                  >
                    ✖
                  </button>
                  <Datepicker
                    v-model="to_date"
                    ref="to_date"
                    typeable
                  ></Datepicker>
                  <label :class="to_date ? 'active' : ''">{{
                    $t("todate")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-xl-2 align-self-center">
              <button
                @click.prevent.stop="onSearchVoucherCode()"
                class="btn btn-blue w-100 px-2"
              >
                {{ $t("apply_filter") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mb-2 font-weight-bold"
      >{{ $t('total') }} {{ $tc('ticket', 1) }} {{ $t('sold') }} - {{Records.length}}</div>
      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th>{{ $t('promocode') }}</th>
              <th>{{ $tc('cinema', 1) }}</th>
              <th>{{ $tc('movie', 1) }} / {{ $tc('item') }} {{ $t('name') }}</th>
              <th>{{ $t('show') }} {{ $t('datetime') }}</th>
              <th>{{ $t('time') }} {{ $t('usage') }}</th>
              <th>{{ $t("transaction_id") }}</th>
              <th>{{ $t('client_name') }}</th>
              <th>{{ $t('client') }} {{ $t('shareValue') }}</th>
              <th>{{ $t('discount') }} {{ $t('amount') }}</th>
              <th>{{ $t('grossAmount') }}</th>
              <th>{{ 'User Name' }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(singleRecord, IndexKey) in Records" :key="IndexKey">
              <td>{{ singleRecord.promo_code || singleRecord.offer_title }}</td>
              <td>{{ singleRecord.cine_name || singleRecord.cinema_name }}</td>
              <td
                v-if="singleRecord.movie_title && singleRecord.movie_title.length > 0"
              >{{ singleRecord.movie_title || singleRecord.item_name }} ({{ singleRecord.mf_name }}) ({{ singleRecord.lang_name }})</td>
              <td v-else>{{ singleRecord.item_name }}</td>
              <td class="text-left">
                {{ singleRecord.t_show_date | dateparse }}
                {{ singleRecord.t_show_time  }}
              </td>
              <td class="text-left">
                {{ singleRecord.created_at | dateparse }}
                {{ singleRecord.created_at | timeparse }}
              </td>
              <td>
                {{
                  singleRecord.sb_booking_code || singleRecord.fnb_order_code || "-"
                }}
              </td>
              <td>{{ singleRecord.client_name }}</td>
              <td>{{ singleRecord.client_share_value }}</td>
              <td>{{ singleRecord.t_offer_price || singleRecord.ft_offer_price }}</td>
              <td>{{ singleRecord.total_amount || singleRecord.ft_gross_amount_before_offer }}</td>
              <td>{{ singleRecord.pos_user || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
       <div
        href="#"
        v-if="Records.length > 0"
        class="d-flex justify-content-end mt-3 align-items-center"
      >
        <div>{{ $t("download") }} as:</div>
        <a
          href="#"
          @click="getOfferUsageDetails('Y')"
          title="Download as Excel"
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
    </div>

    <b-pagination
      v-if="Records && Records.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>


<script>
import MarketingService from "@/services/MarketingService";
import moment from "moment";
import { createQueryString } from "@/services/ApiHelper";

export default {
  data() {
    return {
      roleID: "",
      os_id: "",
      Records: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      searchValue: "",
      from_date: null,
      to_date: null,
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
    };
  },

  beforeMount() {
    this.roleID = this.secureStore.get("USINFO").role_id;
    const { os_id } = this.$route.query;

    // this.getCountriesList();

    if (os_id) {
      this.os_id = os_id;
      this.getOfferUsageDetails();
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getOfferUsageDetails();
      } else {
        this.currentPage = event;
        this.getOfferUsageDetails();
      }
    },
    onSearchVoucherCode() {
        this.currentPage = 1;
        this.getOfferUsageDetails();
      },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    getOfferUsageDetails: function (isExcel = "N") {
      let payload = {
        os_id: this.os_id,
        isExcel: isExcel,
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue || null,
        from_date:
            this.from_date && moment(this.from_date).isValid()
              ? moment(this.from_date).format("YYYY-MM-DD")
              : null,
          to_date:
            this.to_date && moment(this.to_date).isValid()
              ? moment(this.to_date).format("YYYY-MM-DD")
              : null,
      }

      if(isExcel == 'Y') {
        payload['limit'] = 100000;
        payload['currentPage'] = 1;
      }

      if(isExcel == "Y") {
        const qs = createQueryString(payload);
        window.open(`${this.BASE_URL}/api/marketing/viewofferusage/export/${payload.os_id}${qs}`);
      } else {
        MarketingService.GetOfferUsage(payload)
        .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.Records = data.Records;
              this.rows = data.totalRows;
            } else {
              this.$toasted.show("No Records found");
            }
        })
        .catch((error) => {
          this.$toasted.show("Catch Error on: ", error);
        });
      }
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/viewUsagePromotionsAndOffers.vue